var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearchGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_787_93",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3982 0H0.144775V22H22.3982V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_787_93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.4171 15.5833C13.0017 15.5833 15.9077 12.7105 15.9077 9.16669C15.9077 5.62284 13.0017 2.75 9.4171 2.75C5.83244 2.75 2.92651 5.62284 2.92651 9.16669C2.92651 12.7105 5.83244 15.5833 9.4171 15.5833Z",
    stroke: "#C9C9C9",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6163 19.25L14.053 13.75",
    stroke: "#C9C9C9",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchGrey);
export default __webpack_public_path__ + "static/media/Icon_Search_Grey.28cb40c24c60ab9ea5974eefdf44754b.svg";
export { ForwardRef as ReactComponent };